import type { Change, DiffResult, Severity } from './types.js';

const BADGE: Record<Severity, string> = {
  breaking: '🟥 breaking',
  caution: '🟨 caution',
  safe: '🟩 safe',
};

/** Renders the diff as a Markdown checklist suitable for a PR description. */
export function toMarkdown(result: DiffResult): string {
  const lines: string[] = [];
  const { counts } = result;
  const total = result.changes.length;

  lines.push('## Migration diff');
  lines.push('');
  if (total === 0) {
    lines.push('No structural changes detected.');
    lines.push('');
    return lines.join('\n');
  }
  lines.push(
    `${total} change${total === 1 ? '' : 's'}: ` +
      `${counts.breaking} breaking, ${counts.caution} caution, ${counts.safe} safe.`,
  );
  lines.push('');

  for (const severity of ['breaking', 'caution', 'safe'] as const) {
    const group = result.changes.filter((c) => c.severity === severity);
    if (group.length === 0) continue;
    lines.push(`### ${BADGE[severity]}`);
    lines.push('');
    for (const change of group) {
      lines.push(`- [ ] **${change.entity}**${change.column ? `.${change.column}` : ''} — ${change.summary}`);
      lines.push(`      ${change.note}`);
    }
    lines.push('');
  }

  lines.push('---');
  lines.push('_Generated by [Migration Diff Narrator](https://migration-diff-narrator.netlify.app) — rule-based, runs entirely in the browser._');
  lines.push('');
  return lines.join('\n');
}

/** One-line plain-text version of a change, used by tests and the UI tooltip. */
export function changeLine(change: Change): string {
  return `[${change.severity}] ${change.entity}${change.column ? '.' + change.column : ''}: ${change.summary}`;
}
